import { useCallback } from 'react';

import Text from '@zenbusiness/common-components/Text';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import SharedAsset from '#client/components/SharedAsset';
import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { TextArea } from '../../TextArea';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import { useStyles } from '../../Interactive/WorksheetActivity/useStyles';
import { THE_WORLD_NEEDS } from './whatTheWorldNeeds';
import { I_LOVE_TO } from './whatYouLove';

const NEXT_BUTTON_TEXT = 'Next';
export const MY_MISSION_IS = 'myMissionIs';

export const YourMission = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const classes = useStyles();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <Box className={classNames(classes.imageContainer, classes.bottomSpacing)}>
      <SharedAsset
        className={classes.responsiveImage}
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise6.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </Box>
  );
  const summary = <Text size="lg" className={classes.bottomSpacing}>What you love and what the world needs.</Text>;

  return (
    <ExercisePage
      caption="Exercise"
      title="Your mission &#127919;"
      summary={summary}
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(MY_MISSION_IS)}
      onNext={onNextHandler}
    >
      <Text
        size={isMobile ? 'lg' : 'xl'}
        color="wisdom40"
        className={classes.userInputSpacing}
      >
        &#10084;&#65039;
        {' '}
        <strong>I love to</strong>
        {' '}
        {getStorageValue(I_LOVE_TO)}
      </Text>
      <Text
        size={isMobile ? 'lg' : 'xl'}
        color="wisdom40"
        className={classes.bottomSpacing}
      >
        &#127758;
        {' '}
        <strong>The world needs</strong>
        {' '}
        {getStorageValue(THE_WORLD_NEEDS)}
      </Text>
      <TextArea
        placeholder="My misssion is..."
        text={getStorageValue(MY_MISSION_IS)}
        onChangeHandler={(e) => setStorageValue(MY_MISSION_IS, e.target.value)}
        className={classes.bottomSpacing}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <Button
        className={`${classes.nextButton} ${classes.buttonRight}`}
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(MY_MISSION_IS)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </Button>
      )}
    </ExercisePage>
  );
};

YourMission.propTypes = {
  onNext: PropTypes.func
};

YourMission.defaultProps = {
  onNext: () => {}
};

export default YourMission;
